import { createDelegator, animateToggle, toggleClass } from "./domHelpers"

export default function Header(node) {
  node.addEventListener("click", createDelegator(".header-categories-toggle", (e) => {
    e.preventDefault()

    const headerCategories = node.querySelector(".header-categories")
    if (!headerCategories) return

    animateToggle(headerCategories, "is-visible", "is-expanding", "is-collapsing")
  }))

  node.addEventListener("click", createDelegator(".header-category-toggle", (e) => {
    e.preventDefault()

    const category = e.delegateTarget.closest(".header-category")

    node.querySelectorAll(".header-category.is-open").forEach((openCategory) => {
      if (openCategory !== category) setCategoryOpen(openCategory, false)
    })

    setCategoryOpen(category, !category.classList.contains("is-open"))
  }))
}

function setCategoryOpen(category, open) {
  const toggle = category.querySelector(".header-category-toggle")
  const icon = toggle.querySelector(".icon")

  toggleClass(category, "is-open", open)
  toggle.setAttribute("aria-expanded", open)
  icon.classList.replace(open ? "icon-down" : "icon-up", open ? "icon-up" : "icon-down")
}
